import { Tag, Tooltip } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { getVersionInfo, hasVersionInfo } from './getVersionInfo.ts';

// Contenitore non-landmark: il landmark <footer> è già fornito dal tema
const StyledVersionContainer = styled.div`
  padding: 4px 4px 4px 9px;
`;

/**
 * Informazioni di versione nel footer.
 *
 * Se entrambe le versioni sono nascoste (APP_VERSION vuota e
 * SHOW_FRONTEND_VERSION=false) non renderizza nulla.
 */
export function VersionInfo() {
  const { t } = useTranslation();
  const { appVersion, frontendVersion } = getVersionInfo();

  const detail = useMemo(() => {
    const detailParts: string[] = [];
    if (appVersion) {
      detailParts.push(
        t('layout.version-info.app', 'Applicativo {{version}}', {
          version: appVersion,
        }),
      );
    }
    if (frontendVersion) {
      detailParts.push(
        t('layout.version-info.frontend', 'Frontend {{version}}', {
          version: frontendVersion,
        }),
      );
    }
    return detailParts.join(' · ');
  }, [appVersion, frontendVersion, t]);

  if (!hasVersionInfo()) {
    return null;
  }

  return (
    <StyledVersionContainer>
      <Tooltip title={detail} trigger={['hover', 'focus']}>
        <Tag role="note" tabIndex={0} aria-label={detail}>
          {appVersion ?? frontendVersion}
        </Tag>
      </Tooltip>
    </StyledVersionContainer>
  );
}
